module.exports = __webpack_public_path__ + "static/media/1_19-_DSC9505-2.9f81be3b.webp";